import React from 'react';
import ReactDOM from 'react-dom';
import SMSTemplate from '@sfly/uig-sms-template';

/**
 * @description This method is used to render new SMS Template.
 * Wiki link -> https://wiki.corp.shutterfly.com/pages/viewpage.action?spaceKey=sfly&title=SMS+Template+%28uig-sms-template%29+Usage+Guide
 *
 * @param customProps If someone want to change any default values
 * @param customNodeId If someone want to change the default mount node id
 */
window.SMSTemplate = (customProps = {}, customNodeId = '') => {
    const mountNode = document.getElementById(customNodeId || 'sms-template');

    if (mountNode) {
        ReactDOM.render(<SMSTemplate {...customProps} />, mountNode);
    }
};
